<template>
  <div class="side-menu" :class="{ 'active': isMenuOpen }" id="sidebar">
    <div
      class="sidebar-btn close-btn cursor-pointer d-block d-lg-none"
      @click="isMenuOpen = false"
    >
      <i class="ph ph-x fs-two p1-color"></i>
    </div>

    <div class="d-flex">
      <div class="side-menu-right overflow-y-auto">
        <div
          class="d-flex flex-column align-items-center gap-1"
          style="position: absolute !important; z-index: -200"
        >
          <span class="toggle_name fs-eleven n5-color">Light Mode</span>
          <button class="side-icon bg1-color mood_toggle">
            <i class="mood_icon ph-fill fs-six n11-color ph-sun"></i>
          </button>
        </div>
        <div
          class="d-flex flex-column gap-6 justify-content-between py-10 px-5 bgn2-color h-100"
        >
          <div class="">
            <div class="sidebar-profile">
              <div class="position-relative">
                <div
                  class="profile-img1 d-flex justify-content-center overflow-hidden"
                >
                  <img src="assets/images/profile.jpg" alt="user" class="" />
                </div>
              </div>

              <h4 class="n5-color fw-semibold fs-five mt-2 text-center">
                Zakaria Djeddai
              </h4>
              <span class="n5-color fs-nine d-block text-center"
                >Full Stack Developer</span
              >
              <div
                class="d-flex justify-content-center gap-2 align-items-center mt-4"
              >
                <a href="tel:+213669966723" class="social-icon p1-color">
                  <i class="ph ph-phone"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/zakaria-djeddai/"
                  target="_blank"
                  class="social-icon p1-color"
                >
                  <i class="ph ph-linkedin-logo"></i>
                </a>
                <a
                  href="https://github.com/zakareiaa"
                  target="_blank"
                  class="social-icon p1-color"
                >
                  <i class="ph ph-github-logo"></i>
                </a>
                <a
                  href="https://www.instagram.com/zaakareia/"
                  target="_blank"
                  class="social-icon p1-color"
                >
                  <i class="ph ph-instagram-logo"></i>
                </a>
              </div>
            </div>
            <div class="line-divider my-4 my-md-8"></div>

            <div class="menu-list">
              <ul class="d-flex flex-column gap-3">
                <li
                  v-for="item in menuItems"
                  :key="item.name"
                  class="menu-item rounded-3"
                >
                  <router-link
                    :to="{ name: item.name }"
                    :style="{
                      color: $route.name === item.name ? '#fff' : '#000',
                    }"
                    class="d-flex align-items-center gap-2 n5-color fs-eight px-3 py-2 rounded-3"
                    @click="isMenuOpen = false"
                  >
                    <i :class="['ph', item.icon, 'fs-six']"></i>
                    {{ item.label }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <router-link
            :to="{ name: 'contact' }"
            class="primary-btn fw-medium px-3 px-md-6 py-2 py-md-4 rounded-pill d-flex align-items-center gap-2 mx-auto"
          >
            <i class="ph ph-paper-plane-tilt"></i>Hire Me
            <span class="primary-btnSpan"></span
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",

  props: {
    isMenuOpenProp: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      menuItems: [
        {
          name: "index",
          icon: "ph-user",
          label: "About Me",
        },
        {
          name: "resume",
          icon: "ph-notebook",
          label: "Resume",
        },
        {
          name: "portfolio",
          icon: "ph-code-block",
          label: "Portfolio",
        },
        {
          name: "contact",
          icon: "ph-envelope",
          label: "Contact",
        },
      ],

      isMenuOpen: false,
    };
  },

  watch: {
    isMenuOpenProp() {
      this.isMenuOpen = true;
    },
  },
};
</script>

<style>
.menu-item:hover a {
  color: #fff !important;
}

.social-icon {
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: scale(1.1);
}
</style>
